import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';

import useRmfUSPAEnhancedFlow from './USPA/useRmfUSPAEnhancedFlow';
import useRmfUSMIFlow from './useRmfUSMIFlow';

const useRmfUSPAFlow = () =>
  useFeature(FeatureFlag.SwcUSPAEnhancedFlow) ? useRmfUSPAEnhancedFlow() : useRmfUSMIFlow();

export default useRmfUSPAFlow;
